
import { faChevronDown, faChevronUp } from '@fortawesome/pro-regular-svg-icons'
import { contentCategoryEnum } from 'pawpaddock-common/data/content'

export default {
  name: 'Faqs',

  data() {
    return {
      fetchFAQsApi: new this.$ApiModel(),
      faqs: [],
      faChevronDown,
      faChevronUp
    }
  },

  created() {
    this.fetchFAQs()
  },

  methods: {
    async fetchFAQs() {
      try {
        await this.$api.content(this.fetchFAQsApi).getAllPublishedContent(contentCategoryEnum.FAQ)

        this.faqs = this.fetchFAQsApi.response.data.map(faq => ({
          title: faq.title,
          mainContent: faq.mainContent,
          isExpanded: false
        }))
      } catch (error) {
        this.$notify.error('Error fetching FAQs, please reload and try again')
      }
    },

    toggleFaq(faq) {
      if (!faq.isExpanded) {
        this.$analytics.addEvent('FAQ', { title: faq.title })
      }

      faq.isExpanded = !faq.isExpanded
    }
  }
}
